export var UserType;
(function (UserType) {
    UserType["BUSINESS"] = "business";
    UserType["PERSONAL"] = "personal";
})(UserType || (UserType = {}));
